<!-- 会员中心 -->
<template>
  <div class="memberCenter">
    <div class="banner"></div>
    <div class="main">
      <div class="content">
        <div class="main_left">
          <div class="userInfo">
            <img :src="avatar" alt="用户头像" />
            <p>{{ contact }}</p>
          </div>
          <ul>
            <li
              v-for="(item, index) in menuItems"
              :key="index"
              :class="['menu-item', { active: activeIndex === index }]"
              @click="handleMenuClick(index)"
            >
              <img
                :src="
                  activeIndex === index ? item.activeIcon : item.defaultIcon
                "
                alt=""
              />
              <p>{{ item.text }}</p>
            </li>
          </ul>
          <div class="outLogin" @click="logout">
            <img src="../assets/icon/icon9.png" alt="" />
            <p>退出登录</p>
          </div>
        </div>
        <!-- <pre>{{ $store.state.userInfo }}</pre> -->
        <div class="main_right">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from "../api/userApi";

export default {
  data() {
    return {
      avatar: localStorage.getItem("cachedAvatar"),
      contact: "",
      activeIndex: 0,
      isInfoComplete: false,
      menuItems: [
        {
          text: "会员中心",
          defaultIcon: require("../assets/icon/icon1.png"),
          activeIcon: require("../assets/icon/icon1_checked.png"),
        },
        {
          text: "发布专利",
          defaultIcon: require("../assets/icon/icon2.png"),
          activeIcon: require("../assets/icon/icon2_checked.png"),
        },
        {
          text: "发布商标",
          defaultIcon: require("../assets/icon/icon3.png"),
          activeIcon: require("../assets/icon/icon3_checked.png"),
        },
        {
          text: "发布科技成果",
          defaultIcon: require("../assets/icon/icon4.png"),
          activeIcon: require("../assets/icon/icon4_checked.png"),
        },
        {
          text: "技术求购发布",
          defaultIcon: require("../assets/icon/icon5.png"),
          activeIcon: require("../assets/icon/icon5_checked.png"),
        },
        {
          text: "专利需求发布",
          defaultIcon: require("../assets/icon/icon6.png"),
          activeIcon: require("../assets/icon/icon6_checked.png"),
        },
        {
          text: "商标需求发布",
          defaultIcon: require("../assets/icon/icon7.png"),
          activeIcon: require("../assets/icon/icon7_checked.png"),
        },
        {
          text: "我的发布",
          defaultIcon: require("../assets/icon/icon8.png"),
          activeIcon: require("../assets/icon/icon8_checked.png"),
        },
      ],
      // 建立路由路径与索引的映射
      routeMap: {
        "/memberCenter/home": 0,
        "/memberCenter/publish-patent": 1,
        "/memberCenter/publish-trademark": 2,
        "/memberCenter/publish-achievement": 3,
        "/memberCenter/publish-tech-demand": 4,
        "/memberCenter/publish-patent-demand": 5,
        "/memberCenter/publish-trademark-demand": 6,
        "/memberCenter/my-publications": 7,
      },
    };
  },
  async created() {
    // 获取用户信息
    const token = localStorage.getItem("token");
    console.log(token, "token");

    if (!token) {
      this.$router.push("/login");
      return;
    }
    await this.getUserInfo();
    this.checkInfoComplete();
    console.log("Store初始状态:", this.$store.state.userInfo);
  },
  watch: {
    // 监听路由变化，自动更新 activeIndex
    "$route.path": {
      immediate: true, // 立即执行一次
      handler(path) {
        // 查找当前路由对应的索引
        const matchedIndex = Object.entries(this.routeMap).find(
          ([routePath]) => routePath === path
        );

        if (matchedIndex) {
          this.activeIndex = matchedIndex[1];
        }
      },
    },
  },
  methods: {
    // ...mapMutations(["setLoginStatus"]),
    // ...mapActions(["fetchUserInfo", "updateUserAvatar"]), // 映射actions
    // 新增：检查信息是否完整
    checkInfoComplete(userData = null) {
      const dataToCheck = userData || this.$store.state.userInfo || {};
      const requiredFields = ["company", "contact", "email", "qq", "wechat"];

      const isComplete = requiredFields.every(
        (field) =>
          dataToCheck[field] && String(dataToCheck[field]).trim() !== ""
      );

      console.log("完整性检查:", {
        data: dataToCheck,
        isComplete,
        missing: requiredFields.filter(
          (f) => !dataToCheck[f] || !String(dataToCheck[f]).trim()
        ),
      });

      return isComplete; // 确保返回布尔值
    },
    async logout() {
      localStorage.removeItem("token");
      // this.setLoginStatus(false);
      this.$router.push("/login");
    },
    async getUserInfo() {
      try {
        const response = await getUserInfo();
        console.log("用户信息响应:", response.data);
        if (response.code === 1) {
          this.avatar = response.data.avatar;
          this.contact = response.data.contact;
          // 缓存用户信息，避免切换页面时闪烁
          // 更新store
          this.$store.commit("setUserInfo", response.data);

          // 直接使用响应数据检查
          this.isInfoComplete = this.checkInfoComplete(response.data);
          console.log("信息完整状态:", this.isInfoComplete);
        }
      } catch (error) {
        console.error("获取接口失败", error);
      }
    },

    handleMenuClick(index) {
      if (index === 0) {
        this.activeIndex = index;
        this.$router.push("/memberCenter/home");
        return;
      }

      // 检查信息是否完整
      if (!this.isInfoComplete) {
        this.$message.warning("请先完善会员中心的全部信息");
        this.activeIndex = 0; // 强制跳回首页
        this.$router.push("/memberCenter/home");
        return;
      }
      this.activeIndex = index;

      const routes = [
        "home",
        "publish-patent",
        "publish-trademark",
        "publish-achievement",
        "publish-tech-demand",
        "publish-patent-demand",
        "publish-trademark-demand",
        "my-publications",
        // ...对应顺序
      ];
      this.$router.push(`/memberCenter/${routes[index]}`);
    },
  },
};
</script>

<style scoped lang="less">
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
  display: flex;
}
.banner {
  background: url(../assets/banner2.png) no-repeat center/cover;
  width: 100%;
  height: 318px;
}
.main {
  background-color: rgba(245, 245, 245, 1);
  display: flex;
  padding: 20px 0 45px 50px;
  .main_left {
    width: 237px;
    height: 775px;
    background: #ffffff;
    border-radius: 10px;
    margin-right: 20px;
    padding: 15px;
    box-sizing: border-box;
    .userInfo {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 84px;
        height: 84px;
        border-radius: 50%;
        margin-top: 10px;
        margin-bottom: 15px;
      }
      p {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #121212;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 150px;
      }
    }
    ul {
      display: flex;
      flex-direction: column;
      margin-top: 35px;
      border-bottom: 1px solid #f5f5f5;
      padding-bottom: 17px;
      .menu-item {
        display: flex;
        align-items: center;
        width: 207px;
        height: 56px;
        padding: 18px 0 18px 50px;
        box-sizing: border-box;
        cursor: pointer;
        transition: all 0.3s ease;

        img {
          width: 16px;
          height: 16px;
          margin-right: 10px;
        }

        p {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: rgba(18, 18, 18, 0.7);
          transition: color 0.3s ease;
        }

        &.active {
          background: #f1f1f4;
          border-radius: 10px;

          p {
            color: #175dc2;
          }
        }
      }
      li:last-child {
        margin-bottom: 0;
      }
    }
    .outLogin {
      display: flex;
      align-items: center;
      margin-top: 25px;
      margin-left: 50px;
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
        margin-right: 10px;
      }
      p {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #121212;
      }
    }
  }
  .main_right {
    width: 1043px;
    // height: 775px;
    background: #ffffff;
    border-radius: 10px;
  }
}
</style>
